import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '../../../biLogger';
import LazyLoadingImage from '../../../LazyLoadingImage';
import { useFunctionalRef } from '../../../utils/hooks/useFunctionalRef';
import { useAvatarSrc } from './useAvatarSrc';
import s from './BasicUserAvatar.scss';
var MAX_PIXELATED_RESOLUTION = 50;
function isSmallGifImage(img) {
    if (!img.src) {
        return false;
    }
    var imgExtension = img.src.split('?').shift();
    if (!imgExtension) {
        return false;
    }
    imgExtension = imgExtension.split('.').pop();
    return (imgExtension === 'gif' &&
        img.naturalHeight <= MAX_PIXELATED_RESOLUTION &&
        img.naturalWidth <= MAX_PIXELATED_RESOLUTION);
}
var BasicUserAvatar = function (_a) {
    var user = _a.user;
    var t = useTranslation().t;
    var _b = useState(false), shouldBePixelated = _b[0], setPixelated = _b[1];
    var _c = useFunctionalRef(null), imgRef = _c[0], setRef = _c[1];
    var imgSrc = useAvatarSrc(user);
    var onLoad = useCallback(function () {
        if (imgRef.current && isSmallGifImage(imgRef.current)) {
            setPixelated(true);
        }
    }, [imgRef]);
    return (React.createElement(LazyLoadingImage, { "data-hook": BiDataHook.USER_AVATAR, alt: t('avatar.alt', {
            username: user.username || t('avatar.unknownUser'),
        }), className: classnames(s['user-avatar'], shouldBePixelated && s['pixelated']), innerRef: setRef, src: imgSrc, onLoad: onLoad }));
};
BasicUserAvatar.displayName = 'BasicUserAvatar';
export default BasicUserAvatar;
//# sourceMappingURL=BasicUserAvatar.js.map